import StarOutlinedIcon from 'app/ui/icons/StarOutlinedIcon';
import WeatherOutlinedIcon from 'app/ui/icons/WeatherOutlinedIcon';
import clsx from 'clsx';

import { Box, SxProps, Tooltip } from '@mui/material';

interface BookingSpecialProps {
  size?: 'regular' | 'large';
  type?: 'special-inspection' | 'doee';
  tooltip?: string;
}

const getStyles = (): { [key: string]: SxProps } => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '22px',
      height: '22px',
      border: '1.5px solid #67707e',
      fontSize: '1.4rem',
      borderRadius: '3px',
      '&.large': {
        width: '30px',
        height: '30px',
        fontSize: '1.8rem',
        '&.special-inspection': {
          fontSize: '1.8rem',
        },
        '&.doee': {
          fontSize: '2.5rem',
        },
      },
    },
  };
};

export default function BookingSpecial(props: BookingSpecialProps) {
  const { size, type = 'special-inspection', tooltip = 'Special Inspection' } = props;

  const styles = getStyles();

  return (
    <Tooltip
      enterTouchDelay={0}
      leaveTouchDelay={0}
      disableFocusListener
      placement="top-start"
      title={<Box p={0.5}>{tooltip}</Box>}
      arrow
    >
      <Box sx={styles.root} className={clsx(size, type)}>
        {type === 'special-inspection' && <StarOutlinedIcon fontSize="inherit" />}
        {type === 'doee' && <WeatherOutlinedIcon fontSize="inherit" />}
      </Box>
    </Tooltip>
  );
}
